import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import { EmojiEvents, Group, Home, Payment, Person } from '@mui/icons-material';
import {
  CalendarCursor,
  ClipboardList,
  NewspaperVariantOutline,
  TableSearch
} from 'mdi-material-ui';
import CollapsibleMenuItem from 'components/shared/menus/CollapsibleMenuItem';
import MenuItem from 'components/shared/menus/MenuItem';
import NestedMenuItem from 'components/shared/menus/NestedMenuItem';
import routes from 'common/routes';
import SidebarPanelContext from 'context/SidebarPanelContext';

function SupervisorDesktopMenu() {
  const { t } = useTranslation(['routes']);
  // Rail colapsado: lo decide el panel host (desktop mini / mobile expandido).
  const { iconOnly: shouldUseIconOnly } = useContext(SidebarPanelContext);

  return (
    <List>
      <MenuItem
        icon={<Home />}
        iconOnly={shouldUseIconOnly}
        itemKey="home"
        label={t('home', { ns: 'routes' })}
        path={routes.dashboardSupervisor.path}
      />
      <MenuItem
        icon={<NewspaperVariantOutline />}
        iconOnly={shouldUseIconOnly}
        itemKey="news"
        label={t('news.list', { ns: 'routes' })}
        path={routes.listNews.path}
      />
      <MenuItem
        icon={<CalendarCursor />}
        iconOnly={shouldUseIconOnly}
        itemKey="calendar"
        label={t('session.calendar', { ns: 'routes' })}
        path={routes.calendar.path}
      />
      <MenuItem
        icon={<TableSearch />}
        iconOnly={shouldUseIconOnly}
        itemKey="sessions"
        label={t('session.list', { ns: 'routes' })}
        path={routes.listSession.path}
      />
      <MenuItem
        icon={<ClipboardList />}
        iconOnly={shouldUseIconOnly}
        itemKey="plans"
        label={t('plan.list', { ns: 'routes' })}
        path={routes.listPlan.path}
      />
      <MenuItem
        icon={<EmojiEvents />}
        iconOnly={shouldUseIconOnly}
        itemKey="ranking"
        label={t('gamification.globalRanking', { ns: 'routes' })}
        path={routes.globalRanking.path}
      />

      <CollapsibleMenuItem
        icon={<Payment />}
        iconOnly={shouldUseIconOnly}
        label={t('payment.payments', { ns: 'routes' })}
        tourKey="payments"
        noLink>
        <NestedMenuItem
          label={t('payment.summary', { ns: 'routes' })}
          path={routes.payments.path}
        />
        <NestedMenuItem
          label={t('client.list', { ns: 'routes' })}
          path={routes.listClientPayments.administrator.path}
        />
        <NestedMenuItem
          label={t('trainer.list', { ns: 'routes' })}
          path={routes.listTrainerPayments.administrator.path}
        />
      </CollapsibleMenuItem>
      <CollapsibleMenuItem
        icon={<Group />}
        iconOnly={shouldUseIconOnly}
        label={t('users', { ns: 'routes' })}
        tourKey="users"
        noLink
        path={routes.users.path}>
        <NestedMenuItem label={t('client.list', { ns: 'routes' })} path={routes.listClient.path} />
        <NestedMenuItem
          label={t('trainer.list', { ns: 'routes' })}
          path={routes.listTrainer.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<Person />}
        iconOnly={shouldUseIconOnly}
        itemKey="profile"
        label={t('profile', { ns: 'routes' })}
        path={routes.supervisorProfile.path}
      />
    </List>
  );
}

export default SupervisorDesktopMenu;
